export default "__VITE_ASSET__DakNmJzl__"